import * as React from 'react';

export function useCallbackRef<T extends (...args: any[]) => any>(callback: T | undefined): T {
  const callbackRef = React.useRef<T | undefined>(callback);

  React.useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  return React.useMemo(
    () =>
      ((...args: Parameters<T>) => {
        return callbackRef.current?.(...args);
      }) as T,
    [],
  );
}
